<div *ngIf="errorResponse && errorResponse.errors" class="alert alert-danger m-0">
  <div *ngFor="let error of errorResponse.errors[fieldName]">
    <span>{{ error }}</span>
  </div>
</div>
